export default __webpack_public_path__ + "static/style3.1_Andrey-19788759f3266732f44ebf3f9662a7f7.wav";